<template>
  <div class="registration-form">
    <slot name="header" v-if="!submitted">
      <div class="registration-form__header">
        <span>Register for Resumes and Reels</span>
        <v-btn class="close" elevation="0" @click="close" icon>
          <v-icon>$close</v-icon>
        </v-btn>
        <div class="page-intro">
          <p class="page-intro">
            This year we are offering a chance to get your work and resume
            critiqued by an industry professional who will give you direct
            feedback on how to positively solidify your body of work!
          </p>
          <p class="page-intro">
            The format will be a 20-30 min. Zoom conversation with someone from
            the filmmaking industry that we will pair you with.
          </p>
          <p class="page-intro">
            These conversations will occur the week of Terminus on these dates
            and times:
          </p>
          <ul>
            <li>June 22, 23, & 24</li>
            <li>Scheduled sessions between 1:00-4:00 pm EST</li>
          </ul>
          <br />
          <p class="page-intro">
            If you are interested in participating, please fill out this form to
            register. Sessions are limited and first come, first served, so
            unfortunately registration does not guarantee your spot.
          </p>
        </div>
      </div>
    </slot>
    <v-form
      lazy-validation
      v-model="isFormValid"
      ref="form"
      @submit.prevent="submit"
      v-if="!submitted"
    >
      <v-layout :wrap="['sm', 'xs'].includes($size)">
        <v-flex xs12 sm12 md6>
          <v-text-field
            v-model="form.first_name"
            :rules="[validation.required]"
            label="First name"
            validate-on-blur
          ></v-text-field>
        </v-flex>
        <v-flex class="px-3"></v-flex>
        <v-flex xs12 sm12 md6>
          <v-text-field
            v-model="form.last_name"
            :rules="[validation.required]"
            label="Last name"
            validate-on-blur
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout :wrap="['sm', 'xs'].includes($size)">
        <v-flex xs12 sm12 md6>
          <v-text-field
            v-model="form.email"
            :rules="[validation.required, validation.email]"
            type="email"
            label="Email address"
            validate-on-blur
          ></v-text-field>
        </v-flex>
        <v-flex class="px-3"></v-flex>
        <v-flex xs12 sm12 md6>
          <v-text-field
            label="Phone number"
            v-model="form.phone"
            type="text"
            :rules="[validation.required, validations.onboarding.phone]"
            v-mask="'###-###-####'"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout :wrap="['sm', 'xs'].includes($size)">
        <v-flex xs12 sm12 md6>
          <v-text-field
            v-model="form.school"
            :rules="[validation.required]"
            label="School"
            type="text"
            validate-on-blur
          ></v-text-field>
        </v-flex>
        <v-flex class="px-3"></v-flex>
        <v-flex xs12 sm12 md6>
          <v-text-field
            label="CMF Movie Title(s)"
            v-model="form.movie_titles"
            type="text"
            :rules="[validation.required]"
            validate-on-blur
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-checkbox
        class="agree-checkbox"
        v-model="form.available_22"
        label="I will be available from 1-4 pm EST on June 22, 2021."
        hide-details
      ></v-checkbox>

      <v-checkbox
        class="agree-checkbox"
        v-model="form.available_23"
        label="I will be available from 1-4 pm EST on June 23, 2021."
        hide-details
      ></v-checkbox>

      <v-checkbox
        class="agree-checkbox"
        v-model="form.available_24"
        label="I will be available from 1-4 pm EST on June 24, 2021."
        hide-details
      ></v-checkbox>
      <br />
      <br />
      <v-btn
        :disabled="loading"
        x-large
        type="submit"
        color="primary"
        elevation="0"
        >{{ loading ? "Processing..." : "Submit" }}</v-btn
      >
      <br />
      <br />
      <Recaptcha />
    </v-form>
    <div v-else class="pa-8 text-center">
      <v-btn class="close" @click="close" icon elevation="0">
        <v-icon>$close</v-icon>
      </v-btn>
      <div style="margin: auto auto 4em">
        <div class="h2">
          Thank you! Your registration has been recieved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from "@/mixins/form.mixin";
import validations from "@/data/validations";

export default {
  name: "RegistrationPage",
  metaInfo: {
    titleTemplate: "%s - Registration"
  },
  extends: formMixin,
  data() {
    return {
      loading: false,
      validations,
      submitted: false,
      eventName: "Resumes & Reels",
      form: {}
    };
  },
  created() {
    this.reset();
  },
  methods: {
    async submit() {
      if (
        !this.form.available_22 &&
        !this.form.available_23 &&
        !this.form.available_24
      ) {
        return this.$alert(
          "Please indicate which days you're available to attend.",
          "error"
        );
      }
      try {
        this.loading = true;
        if (!this.validate()) return;
        await this.$recaptchaLoaded();
        const recaptcha = await this.$recaptcha("login");

        await this.$api.RegistrationRequest.create({
          request: this.form,
          recaptcha
        });
        // this.form = {};
        this.loading = false;
        //this.$router.push("/");
        this.submitted = true;
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.reset();
      this.$emit("close");
      this.submitted = false;
    },
    reset() {
      this.form = {
        first_name: this.currentUser?.first_name || "",
        last_name: this.currentUser?.last_name || "",
        email: this.currentUser?.email || "",
        event_name: this.eventName
      };
    }
  }
};
</script>

<style scoped lang="scss">
.registration-form {
  color: $cmf-darkgrey;
  position: relative;

  p {
    font-size: 20px;
  }

  form {
    padding: 0 120px 50px;
  }

  &__header {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 80px 120px 25px;
    font-weight: 300;
    font-size: 36px;
    line-height: 45px;
    letter-spacing: -0.02em;
  }
}
.v-btn--outlined .v-btn__content .v-icon,
.v-btn--round .v-btn__content .v-icon {
  &::v-deep {
    color: $primary;
  }
}
</style>
